import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import Reference from '@/fhirworks/types/Reference';

/**
 * One follow-up on whether an as-needed dose worked.
 *
 * Stamped with who wrote it and when, because the nurse following up is often not the one who gave
 * the dose and a surveyor asks for both. Entries are appended and never edited.
 */
export default class EffectivenessEntry extends BackboneElement {
    static __className = 'EffectivenessEntry';

    __objectStructure = {
        text: String,
        author: Reference,
        time: String,
    };

    constructor(constructJson, className = 'EffectivenessEntry') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
